module.exports = __webpack_public_path__ + "img/Logo-Empresas-830x354.f7b34b1d.png";